import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18.54 18.54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.27 17.89C14.0307 17.89 17.89 14.0307 17.89 9.27C17.89 4.50931 14.0307 0.65 9.27 0.65C4.50931 0.65 0.65 4.50931 0.65 9.27C0.65 14.0307 4.50931 17.89 9.27 17.89Z",
			stroke: "currentColor",
			strokeWidth: 1.55,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M5.41562 9.82084L7.71963 12.1248L13.4796 6.36484",
			stroke: "currentColor",
			strokeWidth: 1.55,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgTaskCheck;
